import { GetIchraClassDesignWizardStateResponse } from 'core'

import { NavItemProps } from '../../../common/productClassWizardModal/models'
import SetAllowances from './setAllowances'
import SetClassTitle from './setClassTitle'
import SetEligibleExpenses from './setEligibleExpenses'
import SetWaitingPeriod from './setWaitingPeriod'

export enum IchraRenewalProductClassWizard {
  SetSetClassTitle = 'ichra-renewal-class-set-title',
  SetEligibleExpenses = 'ichra-renewal-class-design-select-eligible-expenses',
  SetAllowances = 'ichra-renewal-class-design-set-allowance',
  SetWaitingPeriod = 'ichra-renewal-class-design-set-waiting-period',
}

export const IchraRenewalProductClassWizardNavItemsMapping: NavItemProps[] = [
  {
    key: IchraRenewalProductClassWizard.SetSetClassTitle,
    component: SetClassTitle,
    nextButtonTooltip:
      'admin-dashboard.benefit-details.class-design.select-class.modal-steps-tooltip.qsehra.select-expense-tooltip',
    mapState: (state: GetIchraClassDesignWizardStateResponse | undefined): any => {
      return {
        productClassId: state ? state.id : '',
        classTypeIds: state ? state.classTypeIds : [],
        stateId: state ? state.stateId : '',
      }
    },
  },
  {
    key: IchraRenewalProductClassWizard.SetEligibleExpenses,
    component: SetEligibleExpenses,
    nextButtonTooltip:
      'admin-dashboard.benefit-details.class-design.select-class.modal-steps-tooltip.qsehra.select-expense-tooltip',
    mapState: (state: GetIchraClassDesignWizardStateResponse | undefined): any => {
      return {
        productClassId: state ? state.id : '',
        reimbursementProduct: state ? state.reimbursementProduct : null,
      }
    },
  },
  {
    key: IchraRenewalProductClassWizard.SetAllowances,
    component: SetAllowances,
    nextButtonTooltip:
      'admin-dashboard.benefit-details.class-design.select-class.modal-steps-tooltip.qsehra.set-allowance-tooltip',
    mapState: (state: GetIchraClassDesignWizardStateResponse | undefined): any => {
      return {
        productClassId: state ? state.id : null,
        familyAllowances: state ? state.familyAllowances ?? [] : [],
        offerSameAllowance: state ? state.offerSameAllowance : null,
      }
    },
  },
  {
    key: IchraRenewalProductClassWizard.SetWaitingPeriod,
    component: SetWaitingPeriod,
    nextButtonTooltip:
      'admin-dashboard.benefit-details.class-design.select-class.modal-steps-tooltip.qsehra.set-waiting-period-tooltip',
    mapState: (state: GetIchraClassDesignWizardStateResponse | undefined): any => {
      return {
        productClassId: state ? state.id : '',
        waitingPeriod: state.waitingPeriod,
      }
    },
  },
]
